import {Dropdown, message, Modal} from 'antd';
import {LinkButton} from '../../../../../../../Features/Buttons/LinkButton';
import {
    changeStatus,
    deleteDict,
    DictListItem,
    nodeMoveDown,
} from '../../../../service';
import {errorMessage} from '../../../../../../../Utils/common';
import useAuth from '../../../../../../../Utils/Hooks/useAuth';

interface DictManageMenuProps {
    data: DictListItem;
    onChange(): void;
}

export function DictManageMenu({data, onChange}: DictManageMenuProps) {
    const auth = useAuth();

    const isChild = data.parentId !== '0';
    const typeName = isChild ? '子项' : '维度';

    function onDelete() {
        Modal.confirm({
            content: `确定要删除该${typeName}吗`,
            onOk: async () => {
                try {
                    await deleteDict(data.id);
                    message.success('删除成功');
                    onChange();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            },
        });
    }

    function onChangeStatus() {
        const status = data.status === '1' ? '0' : '1';
        const action = status === '1' ? '启用' : '停用';

        Modal.confirm({
            content: `确定要${action}该${typeName}吗`,
            onOk: async () => {
                try {
                    await changeStatus(data.id, status);
                    message.success(`${action}成功`);
                    onChange();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            },
        });
    }

    async function onMoveDown() {
        try {
            await nodeMoveDown(data.id);
            onChange();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Dropdown
            menu={{
                items: [
                    {
                        label: data.status === '1' ? '停用' : '启用',
                        key: '1',
                        onClick: onChangeStatus,
                        disabled: !auth('SF_J476Zfxw18'),
                    },
                    {
                        label: '删除',
                        key: '2',
                        onClick: onDelete,
                        disabled: !auth('SF_J476Zfxw17'),
                    },
                    isChild
                        ? {
                              label: '下移',
                              key: '3',
                              onClick: onMoveDown,
                              disabled: !auth('SF_J476Zfxw19'),
                          }
                        : null,
                ],
            }}>
            <LinkButton>更多</LinkButton>
        </Dropdown>
    );
}
